import React, { useEffect } from "react";
import Success from "./Success";
import { SignUpPathEnum } from "constants/signUpPath";
import { Route, Routes, useNavigate } from "react-router-dom";
import BusinessInfo from "./BusinessInfo";
import EmailInfo from "./EmailInfo";
// import { StepperSlider } from "components/styles";
// import { Step, StepLabel } from "@mui/material";
import AddressInfo from "./AddresInfo";
import NotFound from "./NotFound";
import { useAppSelector } from "hooks/useReduxHook";
import EmailVerify from "./EmailVerify";
import Survey from "components/Survey";
import {Container} from "@mui/material";

// import TypingEffect from "components/TypingEffect";

// const titleMapping = (path) => {
//   const data = {
//     nameInfo: "Let’s Get Started",
//     businessInfo: "",
//     emailInfo: "",
//     emailVerify: "",
//   };
//   return {};
// };

const Stepper = () => {
  const navigate = useNavigate();
  const errorData = useAppSelector((state) => state.error);
  // const errorData = useAppSelector(errorSelector.errorData);

  useEffect(() => {
    if (errorData?.data?.errorMessage) {
      navigate("/notFound");
    }
  }, [errorData?.data, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // if (errorData.errorMessage) {
  //   return <NotFoundTimeout />;
  // }

  return (
    <Container component="main" maxWidth="xs" className={'main-container'}>
      <Routes>
        <Route path={"/"} element={<BusinessInfo />} />
        <Route path={SignUpPathEnum.BUSINESS_INFO} element={<BusinessInfo />} />
        <Route path={SignUpPathEnum.EMAIL_INFO} element={<EmailInfo />} />
        <Route path={SignUpPathEnum.EMAIL_VERIFY} element={<EmailVerify />} />
        <Route path={SignUpPathEnum.ADDRESS_INFO} element={<AddressInfo />} />
        <Route path={"/survey"} element={<Survey />} />
        <Route path={SignUpPathEnum.SIGN_UP_SUCCESS} element={<Success />} />
        <Route path={"/*"} element={<NotFound />} />
      </Routes>
    </Container>
  );
};

export default Stepper;
